var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgScheduler(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 64,
    width: 64,
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "workout plan") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round",
    strokeWidth: 4,
    fill: "none",
    stroke: "currentColor",
    strokeLinejoin: "round",
    className: "nc-icon-wrapper",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("line", {
    x1: 60,
    y1: 23,
    x2: 4,
    y2: 23,
    "data-cap": "butt",
    strokeLinecap: "butt"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15,55H8a4,4,0,0,1-4-4V13A4,4,0,0,1,8,9H56a4,4,0,0,1,4,4V34"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 17,
    y1: 3,
    x2: 17,
    y2: 15
  }), /*#__PURE__*/React.createElement("line", {
    x1: 47,
    y1: 3,
    x2: 47,
    y2: 15
  }), /*#__PURE__*/React.createElement("line", {
    x1: 32,
    y1: 47,
    x2: 51,
    y2: 47,
    "data-cap": "butt",
    strokeLinecap: "butt"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "26 47 21 47 21 53 26 53",
    "data-cap": "butt",
    strokeLinecap: "butt"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "57 53 62 53 62 47 57 47",
    "data-cap": "butt",
    strokeLinecap: "butt"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 32,
    y1: 53,
    x2: 51,
    y2: 53,
    "data-cap": "butt",
    strokeLinecap: "butt"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 38,
    width: 6,
    height: 24,
    rx: 3,
    ry: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 51,
    y: 38,
    width: 6,
    height: 24,
    rx: 3,
    ry: 3
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScheduler);
export default __webpack_public_path__ + "static/media/scheduler.af15122d2245c77a31691439222aee7e.svg";
export { ForwardRef as ReactComponent };